<template>
  <c-analysts-chart v-if="!params.node.group" :mean="params.value">
    <template slot="ariaTitle">
      <span class="sr-only">{{ getAriaText(params) }}</span>
      <span class="sr-only" v-if="accessibilityFeatures">{{
        $t('white-label.components.analystEvaluation.analystEvaluationGraphic')
      }}</span></template
    ></c-analysts-chart
  >
</template>

<script>
import CAnalystsChart from '@custom/CAnalystsChart';
import { getAriaText } from '@utils/helpers';

export default {
  name: 'analysts-renderer',
  components: {
    CAnalystsChart
  },
  methods: {
    getAriaText,
    refresh(params) {
      this.params = params;
      return true;
    }
  },
  computed: {
    accessibilityFeatures() {
      return this.$store.state.applicationSettings.accessibility.settings.accessibilityFeatures;
    }
  }
};
</script>
